import PropTypes from 'prop-types';

import PurchaseOrderCommandBar from './PurchaseOrderCommandBar';
import PurchaseOrderDetailTabs from './PurchaseOrderDetailTabs';
import PurchaseOrderMainInfoCard from './PurchaseOrderMainInfoCard';

const PurchaseOrderBlock = ({ detail, onRefetch, showActions = false }) => (
  <div className="space-y-4">
    <PurchaseOrderMainInfoCard
      detail={detail}
      actions={
        showActions ? (
          <PurchaseOrderCommandBar
            key={`${detail.id}-${detail.record?.updatedAt ?? ''}`}
            detail={detail}
            onRefetch={onRefetch}
          />
        ) : null
      }
    />
    <PurchaseOrderDetailTabs detail={detail} onRefetch={onRefetch} />
  </div>
);

PurchaseOrderBlock.propTypes = {
  detail: PropTypes.object.isRequired,
  onRefetch: PropTypes.func,
  showActions: PropTypes.bool,
};

export default PurchaseOrderBlock;
